// PageTransition.js
import React from "react";
import { motion } from "framer-motion";

const transitionProps = {
  initial: { opacity: 1 }, // Start fully visible
  animate: { opacity: 1 }, // Stay fully visible
  exit: { opacity: 1 },    // Exit fully visible
  transition: { duration: 0 }, // No transition delay
};


export default function PageTransition({ children }) {
  return (
    <motion.div 
      {...transitionProps}
      style={{
        width: '100%',
        height: 'auto',
        minHeight: 'auto',
        overflow: 'visible',
      }}
    >
      {children}
    </motion.div>
  );
}
